
import buildUrl from 'Helpers/Url';
import fr from 'facet-rest';


export async function handleSendPlanMessage(planMessageUrl, fileId) {
  const planMessageResponse = await fr.http.Get(buildUrl(planMessageUrl));
  const planMessageColl = fr.collection(planMessageResponse);
  const pm = planMessageColl.create();
  pm.attr('fileId', fileId);
  await pm.submit();
}
